import { RECAPTCHA_SITE_KEY, RecaptchaLoaderService } from './services/recaptcha.service'
import { recaptchaInterceptor } from './interceptors/recaptcha.interceptor'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { tenantInterceptor } from './interceptors/tenant.interceptor'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TenantConfigService } from './services/tenant.service'
import { inject, NgModule, provideAppInitializer } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { AppRoutingModule } from './app-routing.module'
import { RUNTIME_CONFIG } from '@config/runtime-config'
import { AppComponent } from './app.component'

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        FormsModule,
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule
    ],
    providers: [
        { provide: RECAPTCHA_SITE_KEY, useFactory: () => inject(RUNTIME_CONFIG).recaptcha_key },
        provideAppInitializer(() => inject(TenantConfigService).load()),
        provideAppInitializer(() => inject(RecaptchaLoaderService).init()),
        provideHttpClient(withInterceptors([tenantInterceptor, recaptchaInterceptor]))
    ],
    exports: [],
    bootstrap: [AppComponent]
})
export class AppModule {
}
